/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Shop_Category_Delete_ConfirmInputs */

const vi_shop_category_delete_confirm = /** @type {(inputs: Shop_Category_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xoá danh mục "${i?.name}"? Danh mục sẽ mất khỏi website và Mini App, không hoàn tác được.`)
};

/**

* @param {Shop_Category_Delete_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_category_delete_confirm = /** @type {((inputs: Shop_Category_Delete_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Category_Delete_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_category_delete_confirm(inputs)
});